module.exports = __webpack_public_path__ + "static/img/slide_4_en.3cc7667.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/slider/slide_4_en.png
// module id = ShP8
// module chunks = 0